import { Bean, ValidationRules } from '@dreryk/react-common';

export const ID_MAX_LENGTH = 10;
export const MD5_MAX_LENGTH = 32;
export const ACCEPTED_PDF_FILE_EXTENSIONS = ['.pdf'];
export const VALIDATION_RULES: ValidationRules<Bean> = { required: true };
export const MAX_PDF_FILE_SIZE_IN_BYTES = 5_242_880;
export const MAX_PDF_FILE_NAME_CHARACTERS = 200;
